module.exports = __webpack_public_path__ + "static/img/org-structure.87772f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/aboutus/img/org-structure.png
// module id = 7KgF
// module chunks = 1